import React from "react";
import { Title } from "./Title/Title";
import { ObuStatusFilter, DeviceTypeFilter } from "./filters";
import FilterProvider from "./context/filter";
import { ActionButtons } from "./ActionButtons/ActionButtons";
import useStyles from "./styles";

export const FilterCarMyFleetForm = () => {
  const classes = useStyles();
  return (
    <FilterProvider>
      <Title />
      <div className={classes.content}>
        <div>
          <DeviceTypeFilter />
          <ObuStatusFilter />
        </div>
        <ActionButtons />
      </div>
    </FilterProvider>
  );
};
